<template>
    <div class="page-order page-create-order">
        <div class="container">
            <div class="oval"></div>
            <div class="page-title">结算</div>
            <div class="order-box">
                <div class="page-title">订单商品</div>
                <productItemComp v-for="(item,index) in order.goods" :key="index" :item="item"></productItemComp>
            </div>

            <div class="order-box">
                <div class="page-title">配送资料</div>

                <addressComp ref="addressRef"
                             @selectAddress="selectAddress"></addressComp>
            </div>

            <div class="order-box">
                <div class="page-title">开票资料</div>
                <div class="invoice-box">
                    <el-radio v-model="hasInvoice" label="1">无需发票</el-radio>
                    <el-radio v-model="hasInvoice" label="2">开具发票</el-radio>

                    &nbsp;&nbsp;
                    <el-select v-model="selectInvoiceValue" placeholder="请选择"
                               v-if="hasInvoice==2">
                        <el-option
                                v-for="item in invoiceList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>

                    <div v-if="hasInvoice==2">
                        <p class="no-invoice"
                           v-if="Object.keys(invoiceForm).length === 0">
                            暂无<span class="name">{{selectInvoiceName}}</span>信息，
                            <span @click="invoiceVisible=true">去添加</span>
                        </p>
                        <div class="invoice-item"
                             v-else>
                            <div class="invoice-text">
                                <p v-if="invoiceForm.invoiceName">发票抬头：{{invoiceForm.invoiceName}}</p>
                                <p v-if="invoiceForm.taxesNo">纳税人识别号：{{invoiceForm.taxesNo}}</p>
                                <p v-if="invoiceForm.entAddress">企业注册地址：{{invoiceForm.entAddress}}</p>
                                <p v-if="invoiceForm.bankName">开户行名称：{{invoiceForm.bankName}}</p>
                                <p v-if="invoiceForm.tel">企业注册电话：{{invoiceForm.tel}}</p>
                                <p v-if="invoiceForm.bankNo">开户行账号：{{invoiceForm.bankNo}}</p>
                            </div>

                            <div class="address-btn">
                                <app-button size="md" color="gray-solid"
                                            @click.native="invoiceVisible=true">编辑发票信息
                                </app-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <el-dialog title="发票信息" :visible.sync="invoiceVisible" center width="600px"
                               :before-close="closeInvoiceDailog">
                        <div>
                            <invoiceType1 v-show="selectInvoiceValue==1" ref="invoiceType1Ref"
                                          @submitForm="submitInvoiceForm"></invoiceType1>
                            <invoiceType2 v-show="selectInvoiceValue==2" ref="invoiceType2Ref"
                                          @submitForm="submitInvoiceForm"></invoiceType2>
                            <invoiceType3 v-show="selectInvoiceValue==3" ref="invoiceType3Ref"
                                          @submitForm="submitInvoiceForm"></invoiceType3>
                        </div>
                    </el-dialog>
                </div>
            </div>

            <div class="order-box">
                <div class="page-title">优惠券</div>
                <div class="btn-box">
                    <app-button size="md" class="gray-solid" @click.native="$refs.addCoupon.visible=true">添加优惠券
                    </app-button>
                </div>

                <div v-if="cards.length>0" class="coupon-list">
                    <couponItemComp v-for="(item,index) in cards" :key="index" :info="item"
                                    :class="{'coupon-active':selectCouponId==item.id}"
                                    @click.native="selectCoupon(item.id)"></couponItemComp>
                </div>

                <div v-else class="no-list">
                    <p style="margin:20px 0;">暂无相关优惠券</p>
                </div>

                <couponAddComp ref="addCoupon" @reloadData="reloadData"></couponAddComp>
            </div>

            <div class="page-title">订单备注</div>
            <div class="order-box">
                <div style="width: 400px;">
                    <el-input
                            type="textarea"
                            :rows="3"
                            placeholder="填写备注（100字以内）"
                            v-model="remark">
                    </el-input>
                </div>
            </div>

            <div class="settle-box">
                <div class="info detail">
                    <p><span>商品数量</span>{{order.goodNum}}</p>
                    <p><span>商品总金额</span>¥{{order.oriAmount/100 | number_format}}</p>
                    <p><span>运费</span>¥{{order.freightAmount/100 | number_format}}</p>
                    <p><span>优惠券</span>
                        <font v-if="order.voucherAmount<=0">¥0.00</font>
                        <font v-else>-¥{{order.voucherAmount/100 | number_format}}</font>
                    </p>
                    <!--<p><span>已优惠</span>¥{{order.totalDisAmount/100 | number_format}}</p>-->
                </div>
                <div class="info total">
                    <p><span>总计</span><span class="cost">¥{{order.amount/100 | number_format}}</span></p>
                </div>

                <app-button @click.native="pay" size="md" color="golden-solid">继续</app-button>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import productItemComp from '../../components/product/Item2'; //商品
    import addressComp from "../Address/ListForOrder"; // 地址
    import invoiceType1 from "../Invoice/invoiceType1";
    import invoiceType2 from "../Invoice/invoiceType2";
    import invoiceType3 from "../Invoice/invoiceType3";
    import couponItemComp from '../Coupon/Item'; // 卡券
    import couponAddComp from '../Coupon/Add'; // 卡券

    export default {
        data() {
            return {
                id: '',
                addressList: [],
                order: {},
                cards: [],
                goods: [],
                remark: '',

                selectCouponId: '',
                selectAddressId: '',

                invoiceList: [
                    {name: '普通发票（个人）', value: '1'},
                    {name: '公司（普通发票）', value: '2'},
                    {name: '公司（增值税发票）', value: '3'},
                ],
                selectInvoiceValue: '1',
                invoiceForm: {},
                hasInvoice: '1',
                invoiceVisible: false,
            };
        },
        components: {
            productItemComp, addressComp, couponItemComp, couponAddComp, invoiceType1, invoiceType2,
            invoiceType3
        },
        computed: {
            selectInvoiceName: function () {
                return this.invoiceList.find(x => x.value == this.selectInvoiceValue).name;
            },
        },
        created() {
            this.id = this.$route.query.id;
            this.checkOrder();
        },
        activated() {
        },
        mounted() {
        },
        watch: {
            selectAddressId(curVal, oldVal) {
                if (curVal != oldVal)
                    this.getByAddressAndCoupon();
            },
            selectCouponId(curVal, oldVal) {
                if (curVal != oldVal)
                    this.getByAddressAndCoupon();
            },
            selectInvoiceValue: {
                handler: function (curVal, oldVal) {
                    if (curVal != oldVal) {
                        this.getInvoiceForm(curVal);
                    }
                }, deep: true, immediate: true,
            },
        },
        methods: {
            // 订单信息-取商品列表
            getOrderDetial() {
                this.$api.getOrderDetail(this.id).then((res) => {
                    this.goods = res.goods;
                });
            },
            // 订单核对
            checkOrder() {
                this.$api.checkOrder(this.id).then((res) => {
                    this.addressList = res.addressList;
                    this.order = res.order;
                    this.cards = res.cards;
                });
            },
            // 订单使用卡券
            getByAddressAndCoupon() {
                if (!this.selectAddressId) {
                    this.$message({type: 'info', message: '请选择收货地址！'});
                    return
                }

                var inData = {
                    orderId: this.id,
                    addressId: this.selectAddressId,
                };
                if (this.selectCouponId)
                    inData.cardId = this.selectCouponId;

                this.$api.getByAddressAndCoupon(inData).then((res) => {
                    this.order.oriAmount = res.oriAmount;
                    this.order.freightAmount = res.freightAmount;
                    this.order.voucherAmount = res.voucherAmount;
                    this.order.totalDisAmount = res.totalDisAmount;
                    this.order.amount = res.amount;
                });
            },

            selectCoupon(id) {
                this.selectCouponId = this.selectCouponId == id ? '' : id;
            },
            reloadData() {
                this.$api.checkOrder(this.id).then((res) => {
                    this.cards = res.cards;
                });
            },

            selectAddress(id) {
                this.selectAddressId = id;
            },

            getInvoiceForm() {
                this.getInvoiceListByType();
            },
            // 获得默认发票信息 - by type
            getInvoiceListByType() {
                var typeId = this.selectInvoiceValue;
                this.$api.getInvoiceListByType(typeId).then((res) => {
                    if (res)
                        this.invoiceForm = res;
                    else
                        this.invoiceForm = {};
                });
            },
            // 子组件 - 表单提交发票信息
            submitInvoiceForm(inData) {
                this.invoiceForm.invoiceName = inData.invoiceName;
                this.invoiceForm.taxesNo = inData.taxesNo;
                this.invoiceForm.entAddress = inData.entAddress;
                this.invoiceForm.tel = inData.tel;
                this.invoiceForm.bankName = inData.bankName;
                this.invoiceForm.bankNo = inData.bankNo;

                this.closeInvoiceDailog();
            },
            closeInvoiceDailog() {
                this.invoiceVisible = false;
            },

            pay() {
                //地址
                var selectAddressId = this.selectAddressId;
                if (!selectAddressId) {
                    this.$message({type: 'error', message: '请选择收货地址！'});
                    return
                }

                var inData = {
                    addrId: selectAddressId,
                    orderId: this.id,
                    remark: this.remark,
                };

                var selectCouponId = this.selectCouponId;
                if (selectCouponId)
                    inData.cardId = selectCouponId;

                //开具发票
                if (this.hasInvoice == 2) {
                    inData.invoiceType = this.selectInvoiceValue;

                    var form = this.invoiceForm;
                    inData.invoiceName = form.invoiceName;
                    inData.taxesNo = form.taxesNo;
                    inData.entAddress = form.entAddress;
                    inData.tel = form.tel;
                    inData.bankName = form.bankName;
                    inData.bankNo = form.bankNo;
                }

                this.$api.addOrderAddr(inData).then((res) => {
                    if (res.status == 1) {
                        this.$router.push({
                            path: '/order/pay',
                            query: {
                                id: this.id
                            }
                        });
                    } else {
                        this.$message({type: 'info', message: res.msg});
                    }
                });

            },
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    @import "../../style/page-common";

    .page-order {
        padding: 60px 0;

        .container {
            position: relative;
        }
    }
</style>

<style lang="scss" type="text/scss">
    .page-create-order {
        .order-box {
            margin-top: 20px;
            min-height: 110px;
            position: relative;
            border-bottom: 1px solid #F5F5F5FF;
        }

        .coupon-list {
            margin: 30px 0 50px;

            .coupon-card {
                cursor: pointer;
                opacity: .6;
            }

            .coupon-active {
                opacity: 1;
            }
        }

        .settle-box {
            width: 250px;
            padding: 20px 0 40px;

            .info {
                > p {
                    padding-bottom: 8px;
                    display: flex;
                    justify-content: space-between;

                    font-size: 16px;
                    font-weight: 300;
                    color: #1F1F1FFF;
                    line-height: 22px;

                    > span {
                        font-size: 16px;
                        font-weight: 600;
                        color: #1F1F1FFF;
                        line-height: 22px;
                    }
                }
            }

            .detail {
                border-bottom: 1px dashed #ddd;
                padding-bottom: 5px;
            }

            .total {
                margin-top: 10px;
                margin-bottom: 35px;

                .cost{
                    font-size: 18px;
                    font-weight: 700;
                    color: #dc1d20;
                }
            }
        }

        .invoice-box {
            padding-top: 20px;
            min-height: 60px;

            .invoice-item {
                padding: 20px 0;
                margin-bottom: 20px;
                display: flex;
                justify-content: space-between;

                .invoice-text {
                    min-width: 550px;
                    font-size: 13px;
                    line-height: 18px;
                    padding: 12px 16px;
                    position: relative;
                    color: #1F1F1FFF;

                    p {
                        margin-bottom: 5px;
                    }

                    &.active {
                        border: 1px solid #C19A77FF;

                        &:after {
                            content: '';
                            width: 20px;
                            height: 20px;
                            display: block;
                            position: absolute;
                            right: 0;
                            bottom: 0;
                            background: url("../../assets/images/order/active.png") center no-repeat;
                        }
                    }
                }
            }


            .no-invoice {
                padding: 20px 0;
                /*font-size: 14px;*/

                > span {
                    color: #4A90E2FF;
                    cursor: pointer;

                    &.name {
                        color: #C19A77;
                    }
                }
            }
        }

        .btn-box {
            position: absolute;
            right: 0px;
            top: -5px;
        }
    }
</style>